import { useIsAuthenticated } from "@azure/msal-react";
import React from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import MainLayout from "./components/Navbar/MainLayout";
import { useAppContext } from "./context/AppContext";
import Connection from "./pages/AdminPages/Connection/Connection";
import Dashboard from "./pages/AdminPages/Dashboard/Dashboard";
import DropboxLogin from "./pages/AdminPages/DropBox/dropboxLogin";
import Login from "./pages/AdminPages/Login/Login";
import Organization from "./pages/AdminPages/Organization/Organization";
import QuickLinkGroups from "./pages/AdminPages/QuickLinkGroups/quicklinkgroups";
import QuickLinks from "./pages/AdminPages/QuickLinks/quicklinks";
import UserGroups from "./pages/AdminPages/UserGroups/UserGroups";
import Users from "./pages/AdminPages/Users/Users";
import NotFound from "./pages/CommonPages/NotFound";
import TenantDetails from "./pages/SuperAdminPages/TenantDetails/TenantDetails";
import TenantList from "./pages/SuperAdminPages/Tenants/TenantList";
import ProtectedRoute from "./ProtectedRoute";
// import ExecutionFlow from "./pages/AdminPages/Workflow/ExecutionFlow";
// import ExecutionFlowBuilder from "./pages/AdminPages/Workflow/ExecutionFlowBuilder";
import ExecutionFlowBuilder from "./pages/AdminPages/Workflow/ExecutionFlowBuilder";

const App: React.FC = () => {
  const isAuthenticated = useIsAuthenticated();
  const { userData } = useAppContext();
  return (
    <Router>
      <Routes>
        {/* Redirect to Login page if not authenticated */}
        <Route
          path="/"
          element={
            isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />
          }
        />
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<MainLayout />}>
          {/* Protect these routes */}
          <Route
            path="dashboard"
            element={<ProtectedRoute element={<Dashboard />} />}
          />
          <Route
            path="organization"
            element={<ProtectedRoute element={<Organization />} />}
          />
          <Route
            path="users"
            element={<ProtectedRoute element={<Users />} />}
          />
          <Route
            path="usergroups"
            element={<ProtectedRoute element={<UserGroups />} />}
          />
          <Route
            path="projects"
            element={<ProtectedRoute element={<QuickLinks />} />}
          />
          <Route
            path="projectsgroups"
            element={<ProtectedRoute element={<QuickLinkGroups />} />}
          />
          <Route
            path="tenants"
            element={<ProtectedRoute element={<TenantList />} />}
          />
          <Route
            path="tenants/:id"
            element={<ProtectedRoute element={<TenantDetails />} />}
          />
          <Route
            path="drop-box"
            element={<ProtectedRoute element={<DropboxLogin />} />}
          />
          <Route
            path="connection"
            element={<ProtectedRoute element={<Connection />} />}
          />
          <Route
            path="/execution-flow-builder/:connectionId"
            element={<ProtectedRoute element={<ExecutionFlowBuilder />} />}
          />

          {/* Catch-all: show 404 page for anything else */}
          <Route path="*" element={<ProtectedRoute element={<NotFound />} />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
